import { z } from 'zod';
export const zodCoordinate = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
});
export const zodGameSession = z.object({
    coordinates_fields: z
        .object({
        lat: z.string(),
        lng: z.string(),
    })
        .array(),
    exp_u64: z.string(),
    nonce: z.string(),
});
export const zodAuthedGameSession = z.object({
    coordinates: zodCoordinate.array(),
    exp: z.number(),
    session: zodGameSession,
    signature: z.string(),
});
export const zodGameResult = z.object({
    signature: z.string(),
    message: z.string(),
    tickets: z.number(),
});
